/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the UAApplicationFormIdentifier
 *
 * @class UAApplicationFormIdentifier
 */
class UAApplicationFormIdentifier {
  /**
   * Creates an instance of UAApplicationFormIdentifier.
   * @param {*} json
   * @memberof UAApplicationFormIdentifier
   */
  constructor(json = null) {
    if (json) {
      // string
      this.application_form_id = json.application_form_id;

      // boolean
      this.isPartialApplication = json.isPartialApplication;
    }
  }
}

/**
 * Models the SDExternalUserCOCStatus
 *
 * @class SDExternalUserCOCStatus
 */
class SDExternalUserCOCStatus {
  /**
   * Creates an instance of SDExternalUserCOCStatus.
   * @param {*} json
   * @memberof SDExternalUserCOCStatus
   */
  constructor(json = null) {
    if (json) {
      // string
      this.cocFormID = json.cocFormID;

      // boolean
      this.isCOCInProgress = json.isCOCInProgress;
    }
  }
}

export default {
  UAApplicationFormIdentifier,

  SDExternalUserCOCStatus,
};
